<template>
    <div class="instrumentTime">
        <div class="layout-page-box">
            <el-form :inline="true" label-width="100px" label-position="right" class="search-form">
                <el-form-item label="仪器名称">
                    <el-input v-model.trim="filters.instrumentName" clearable placeholder="请输入仪器名称">
                    </el-input>
                </el-form-item>
                <el-form-item label="仪器规范名称">
                    <el-input v-model.trim="filters.canonicalName" clearable placeholder="请输入规范名称">
                    </el-input>
                </el-form-item>
                <el-form-item label="仪器打印名称">
                    <el-input v-model.trim="filters.printName" clearable placeholder="请输入打印名称">
                    </el-input>
                </el-form-item>
                <el-form-item label="院区">
                    <el-select v-model.trim="filters.areaId" placeholder="请选择院区" clearable>
                        <el-option v-for="(item) in areaList" :key="item.areaCode" :label="item.areaName" :value="item.areaCode"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="科室">
                    <el-select v-model="filters.departmentCode" placeholder="请选择科室" clearable>
                        <el-option v-for="(item) in offices" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备">
                    <el-select v-model="filters.equipment" placeholder="请选择" clearable>
                        <el-option v-for="(item) in device" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="时间">
                    <el-date-picker v-model="filters.startTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search" size="small">查询</el-button>
                </el-form-item>
            </el-form>
            <div class="buttonText">
                <!-- <div class="delete" @click="delAll">批量删除</div>
                <div class="addData" @click="add">新增</div> -->
                <el-button type="warning" @click="add" icon="el-icon-plus">新增</el-button>
                <el-button type="danger" @click="delAll" icon="el-icon-delete">批量删除</el-button>
            </div>
        </div>
        <div class="layout-page-box">
            <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" :height="tableHeight" :header-cell-style="{color:'#626365'}">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column sortable prop="id" label="编号" align="center"></el-table-column>
                <el-table-column sortable prop="instrumentName" label="仪器名称"></el-table-column>
                <el-table-column sortable prop="canonicalName" label="规范名称"></el-table-column>
                <el-table-column sortable prop="printName" label="打印名称"></el-table-column>
                <!-- <el-table-column sortable prop="areaName" label="院区"></el-table-column>
                <el-table-column sortable prop="departmentName" label="科室"></el-table-column> -->
                <el-table-column sortable prop="equipment" label="设备">
                    <template slot-scope="scope">
                        <span v-if="scope.row.equipment==0">否</span>
                        <span v-if="scope.row.equipment==1">是</span>
                    </template>
                </el-table-column>
                <el-table-column sortable prop="createBy" label="添加人"></el-table-column>
                <el-table-column sortable prop="createTime" width="100" label="添加时间"></el-table-column>
                <el-table-column align="center" label="操作" width="160">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="forbidden" label="禁用" width="80">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.forbidden" active-color="#13ce66" inactive-color="#C9C9C9" :inactive-value="0" :active-value="1" @change="change(scope.$index, scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
            </el-pagination>
        </div>
        <!-- 新增编辑身份弹框 -->
        <el-dialog :visible.sync="dialogFormVisible" center class="dialogItem" :close-on-click-modal="false">
            <el-form :model="formData" label-width="100px">
                <el-form-item label="仪器名称">
                    <span slot="label" class="label">
                        <el-popover popper-class="pop" placement="top" trigger="click" content="登记时常用的简称">
                            <span slot="reference">仪器名称</span>
                        </el-popover>
                    </span>
                    <el-input v-model.trim="formData.instrumentName" placeholder="请输入仪器名称" style="width:95%;"></el-input>
                </el-form-item>
                <el-form-item label="规范名称">
                    <span slot="label" class="label">
                        <el-popover popper-class="pop" placement="top" trigger="click" content="规范的名称，暂时没用到">
                            <span slot="reference">规范名称</span>
                        </el-popover>
                    </span>
                    <el-select clearable @input="testSX" v-model="formData.canonicalName" placeholder="请选择仪器规范名称" style="width:95%;">
                        <el-option v-for="(item) in instruments" :key="item.id" :label="item.label" :value="item.label"> </el-option>
                    </el-select>
                    <!-- <el-input v-model.trim="formData.canonicalName" style="width:95%;"></el-input> -->
                </el-form-item>
                <!-- <el-form-item label="治疗意见">
                    <el-checkbox-group @change="testSX" v-model="formData.treatmentOpinion">
                        <el-checkbox v-for="(item,index) in needs" :key="index" :label="item.id">
                            <span>{{item.name}}</span>
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="治疗后反应">
                    <el-checkbox-group @change="testSX" v-model="formData.treatmentReactions">
                        <el-checkbox v-for="(item,index) in lists" :key="index" :label="item.id">
                            <span>{{item.name}}</span>
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item> -->
                <el-form-item label="打印名称">
                    <span slot="label" class="label">
                        <el-popover popper-class="pop" placement="top" trigger="click" content="导出时的名称">
                            <span slot="reference">打印名称</span>
                        </el-popover>
                    </span>
                    <el-input v-model.trim="formData.printName" placeholder="请输入打印名称" style="width:95%;"></el-input>
                </el-form-item>
                <div v-for="(domain, index) in formData.areaList" :key="index">
                    <div class="instrucPosition">
                        <el-form-item label="院区/科室">
                            <el-select @input="testSX" @focus="areaFocus($event,index)" v-model="domain.areaId" placeholder="请选择院区" style="width:45%;float:left;margin-left:2.5%;">
                                <el-option v-for="(item) in areaList" :key="item.areaCode" :label="item.areaName" :value="item.areaCode" :disabled="item.disabled"> </el-option>
                            </el-select>
                            <el-select multiple v-model="domain.departmentCode" placeholder="请选择科室" style="width:43%;margin-right:5.1%;">
                                <el-option v-for="(item) in offices" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                            </el-select>
                            <el-button size="mini" type="danger" @click.prevent="removeArea(domain)">
                                <i class="el-icon-delete"></i>
                            </el-button>
                        </el-form-item>
                    </div>
                </div>
                <el-form-item style="text-align: right;margin-right:5%;">
                    <el-button @click="addArea" type="primary" size="mini">新增院区</el-button>
                </el-form-item>
                <el-form-item label="设备">
                    <el-select v-model="formData.equipment" placeholder="请选择" clearable style="width:95%;">
                        <el-option v-for="(item) in device" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer partFooter">
                <el-button type="danger" @click="dialogFormVisible=false">取 消</el-button>
                <el-button type="primary" @click="doAddgoods()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { mapState, } from 'vuex'

export default {
    name: "configuration",
    computed: {
        ...mapState(['areaOptions', 'needs', 'lists', 'instruments',]),
    },
    data() {
        return {
            filters: {
                types: '',
                pagination: {
                    page: 1,
                    limit: 10,
                    total: 0
                },
                startTime: '',
                endTime: '',
                outpatientService: '',
            },
            tableData: [],
            multipleSelection: [],
            dialogFormVisible: false,
            formData: {
                treatmentReactions: [],
                treatmentOpinion: [],
            },
            tableHeight: '',
            ranks: [],
            offices: [
                {
                    name: '美容皮肤科',
                    id: '001'
                },
                {
                    name: '美容外科',
                    id: '002'
                },
                {
                    name: '注射微整科',
                    id: '003'
                },
            ],
            device: [
                {
                    name: '是',
                    id: '1',
                }, {
                    name: '否',
                    id: '0',
                },
            ],
            disabled: false,
            areaList: [],
        }
    },
    created() {
        this.areaList = this.areaOptions
        this.tableHeight = document.documentElement.clientHeight - 380
    },
    mounted() {
        /*this.init();*/
        this.query(this.filters.pagination.page);
    },
    watch: {
        $route(to, from) {
            if (this.activatedFlag) {
                this.query(this.filters.pagination.page);
            }
        },
    },
    methods: {
        testSX() {
            this.$forceUpdate()
        },
        search() {
            this.filters.pagination.page = 1
            this.refresh()
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        pageChanged(page) {
            this.filters.pagination.page = page
            this.refresh()
        },
        handleSizeChange(sizes) {
            this.filters.pagination.limit = sizes
            this.refresh()
        },
        refresh() {
            router.push({
                path: this.$route.path,
                query: _.merge({}, this.$route.query, {
                    __query: JSON.stringify(this.pagination)
                }, {
                        random: Math.random()
                    })
            })
        },
        addArea() {
            this.formData.areaList.push({
                areaId: '',
                departmentCode: '',
                key: Date.now()
            });
            this.$forceUpdate()
        },
        removeArea(item) {
            var index = this.formData.areaList.indexOf(item)
            if (index !== -1) {
                this.formData.areaList.splice(index, 1)
            }
            this.$forceUpdate()
        },
        // 判断是否添加重复院区
        areaFocus(val, index) {
            this.areaList = [{
                areaName: '上伯',
                areaCode: '001'
            }, {
                areaName: '上百',
                areaCode: '002'
            }, {
                areaName: '上翡',
                areaCode: '003'
            }, {
                areaName: '北百',
                areaCode: '004'
            }, {
                areaName: '温伯',
                areaCode: '005'
            }, {
                areaName: '重百',
                areaCode: '006'
            }, {
                areaName: '南伯',
                areaCode: '007'
            }]
            this.formData.areaList.map((x, i) => {
                this.areaList.map((s) => {
                    if (x.areaId == s.areaCode) {
                        s.disabled = true
                    }
                })
            })
            this.$forceUpdate()
        },
        handleEdit(index, row) {
            this.dialogFormVisible = true
            let querys = {
                id: row.id,
            }
            api.requestQuiet("/menu/findInstrumentMenuById", querys, (res) => {
                if (res.result == true) {
                    this.formData = res.data
                    this.formData.areaList.forEach(item => {
                        item.departmentCode = item.departmentCode.split(',')
                    });
                    // this.formData.treatmentReactions = this.formData.treatmentReactions.split(',')
                    // this.formData.treatmentOpinion = this.formData.treatmentOpinion.split(',')
                    this.$forceUpdate()
                } else {
                    _g.toast("error", res.errMsg);
                }
            }, (err) => { });
        },
        // 新增项目
        add() {
            this.dialogFormVisible = true
            // 新增置空
            this.formData = {
                areaList: [{
                    areaId: '',
                    departmentCode: '',
                }],
                treatmentOpinion: [],
                treatmentReactions: [],
            }
        },
        doAddgoods() {
            this.formData.areaList.forEach(item => {
                item.departmentName = []
                this.areaOptions.forEach(ele => {
                    if (ele.areaCode == item.areaId) {
                        item.areaName = ele.areaName
                    }
                });
                this.offices.forEach(ite => {
                    item.departmentCode.forEach(ele => {
                        if (ite.id == ele) {
                            item.departmentName.push(ite.name)
                        }
                    });
                });
                item.departmentCode = item.departmentCode.toString()
                item.departmentName = item.departmentName.toString()
            });
            let querys = {
                id: this.formData.id,
                instrumentName: this.formData.instrumentName,
                canonicalName: this.formData.canonicalName,
                printName: this.formData.printName,
                equipment: this.formData.equipment,
                createBy: Lockr.get('skinEmpId'),
                areaList: this.formData.areaList,
                // treatmentOpinion: this.formData.treatmentOpinion.toString(),
                // treatmentReactions: this.formData.treatmentReactions.toString(),
            }
            api.request("/menu/createInstrumentMenu", querys, (res) => {
                if (res.result == true) {
                    this.dialogFormVisible = false
                    _g.toast("success", '操作成功');
                    this.query(this.filters.pagination.page)
                } else {
                    _g.toast("error", res.errMsg);
                }
            }, (err) => { });
        },
        // 批量删除
        delAll() {
            var data = this.multipleSelection;
            var id = [];
            data.map(function (item, index) {
                console.log(item)
                id.push(item.id);
            });
            this.$confirm("确定要删除选中的数据吗？", "删除项目", {
                center: true,
            })
                .then((res) => {
                    api.requestQuiet("/menu/deleteInstrumentMenuAll", { idList: id.toString(), },
                        (res) => {
                            if (res.result == true) {
                                _g.toast("success", "删除成功");
                                this.query(this.filters.pagination.page);
                            } else {
                                _g.toast("error", "删除失败");
                                this.query(this.filters.pagination.page);
                            }
                        }
                    );
                })
                .catch((err) => {
                    // this.$message.error('删除失败！');
                });
        },
        change(index, row) {
            let data = {
                id: row.id
                // 0：正常 1：禁用
            }
            api.request("/menu/updateInstrumentMenuForbidden", data, (res) => {
                if (res.result == true) {
                    _g.toast("success", "状态修改成功")
                    this.query(this.filters.pagination.page)
                } else {
                    _g.toast("error", "状态修改失败")
                    this.query(this.filters.pagination.page)
                }
            })
        },
        // 查询数据列表
        query(page) {
            // console.log(this.filters.startTime)
            var querys = {
                startTime: '',
                endTime: '',
                page: page,
                size: this.filters.pagination.limit,
                instrumentName: this.filters.instrumentName,
                canonicalName: this.filters.canonicalName,
                printName: this.filters.printName,
                areaId: this.filters.areaId,
                departmentCode: this.filters.departmentCode,
                equipment: this.filters.equipment
            }
            if (this.filters.startTime) {
                querys.startTime = this.filters.startTime[0]
                querys.endTime = this.filters.startTime[1]
            }
            api.request('/menu/findInstrumentMenuPage', querys, (res) => {
                var data = res.data.list
                this.tableData = data
                this.filters.pagination.total = parseInt(res.data.count)
            })
        },
    },


}
</script>
<style scoped>
@import "../../assets/css/main.css";
.instrucPosition >>> .el-button i {
  margin: 0 !important;
}
.label {
  cursor: pointer;
}
</style>
<style>
.pop {
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #dcdfe6;
}
.popper__arrow::after {
  border-top-color: #dcdfe6;
}
</style>
